import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AccountUserService } from 'src/app/service/account.service';



@Injectable()
export class ProductsService {

    appUrl = "";
    localAppUrl = "";
    coreUrl = "";
    user: any;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: HttpClient, private accountUserService: AccountUserService,
    ) {
        this.appUrl = environment.apiUrl + "Cases/";
        this.coreUrl = environment.coreUrl;
        this.localAppUrl = environment.localApiUrl;
        this.getCurrentToken();
    }

    getProductList(accountId, productsId, warehouseId) {
        return this.http.get<any>(`${environment.inventoryURl}Product/WarehouseProductByPriceTier?accountId=${accountId}&productIds=${productsId}&warehouseId=${warehouseId}`)

    }

    getLoggedUser(userId) {
        return this.http.get<any>(this.localAppUrl + 'users/' + userId)
            .toPromise()
            .then(res => res);
    }

    getCurrentToken() {
        this.accountUserService.user.subscribe(x => this.user = x);

    }

    updateUser(user) {
        return this.http.put(this.localAppUrl + 'users/' + user.id, user, { headers: this.headers })
            .toPromise()
            .then(() => user);
    }

    getAllInventoryGroups(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Group`);
    }

    getAllAccountType(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}FinancialAccountType?parentAccountTypeId=0`);
    }

    getClasses(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}Class/ClassHierarchy`);
    }

    getAccountTypeData(typeId): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=${typeId}`);
    }

    getAllFinancialAccounts(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount?accountType=0&showBalance=false`);
    }

    getAllImportFinancialAccounts(): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount/ImportFinanceList?accountType=0`);
    }

    getImportAccountTypeData(typeId): Observable<any> {
        return this.http.get<any>(`${environment.financeURl}FinancialAccount/ImportFinanceList?accountType=${typeId}`);
    }

    getAllGroupTypes(id): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${id}`);
    }

    getAllWarranty(id): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${id}`);
    }

    getAllVendors(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Vendor?PageNumber=0&PageSize=0&SearchValue=&SearchColumns=Vendorname&SortBy=CreatedDate&IsAscending=true&filter=allvendors`);

    }

    getvendorsDD(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Vendor/AllVendorDetails?PageSize=0&PageNumber=0&SearchValue=`);
    }

    getvendorsByPagination(pageNumber: number, pageSize: number, searchValue: string): Observable<any> {
        return this.http.get(`${environment.inventoryURl}Vendor/AllVendorDetails?PageSize=${pageSize}&PageNumber=${pageNumber}&SearchValue=${searchValue}`, { observe: 'response' });
    }

    getAllProductChannel(name): Observable<any> {
        return this.http.get<any>(`${environment.configUrl}Configuration/Name?name=${name}`);
    }

    getProductConfigurations(name): Observable<any> {
        return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=${name}`);
    }

    getBrandList(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Brand`);
    }

    getmanufacturerList(): Observable<any> {
        return this.http.get<any>(`${environment.coreUrl}Manufacturer`);
    }

    getmanufacturerCountry(): Observable<any> {
        return this.http.get<any>(`${environment.coreUrl}Country`);
    }


    getProductOwner(organizationId): Observable<any> {
        return this.http.get<any>(`${environment.appOrgUrl}User?organizationId=${organizationId}`);
    }

    getAllProductCategoryList(typeId): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Category/CategoryHierarchy?groupId=${typeId}`);
    }

    getAllWareHouses(): Observable<any> {
        let params = new HttpParams();
        params = params.append('PageNumber', '0')
        params = params.append('PageSize', '0')
        params = params.append('IsAscending', 'true')
        params = params.append('SortBy', 'CreatedDate')
        params = params.append('filter', 'allwarehouses')
        return this.http.get<any>(`${environment.inventoryURl}WareHouse`, { params });
    }

    getAllLocations(): Observable<any> {
        let params = new HttpParams();
        params = params.append('PageNumber', '0')
        params = params.append('PageSize', '0')
        params = params.append('SearchValue', '')
        return this.http.get<any>(`${environment.inventoryURl}WareHouse/AllWarehouseDetails`, { params });
    }

    getAllProductVisibilityList(typeId): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${typeId}`);
    }

    getAllCustomerTypes(typeId): Observable<any> {
        return this.http.get<any>(`${environment.apiUrlAccount}Type?groupId=${typeId}`);
    }

    getAllTerritory(): Observable<any> {

        let params = new HttpParams();
        params = params.append('PageNumber', '0')
        params = params.append('PageSize', '0')
        params = params.append('IsAscending', 'true')
        params = params.append('SortBy', 'CreatedDate')
        params = params.append('objectNameList', 'territoryuser')

        return this.http.get<any>(`${environment.territoryURL}Territory?loginUserId=${this.user.userId}`, { params });
    }

    getAllMeasurements(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}UOMDetail?showEnabled=true`,);
    }

    getUOMByCategory(categoryId) {
        return this.http.get<any>(`${environment.inventoryURl}UOMDetail/UOMByCategory?categoryId=${categoryId}`);
    }

    getInventoryGroupList() {
        return this.http.get<any>(`${environment.inventoryURl}Group`);
    }


    getInventoryCategory(id) {
        return this.http.get<any>(`${environment.inventoryURl}Category?groupId=${id}`);
    }

    getInventoryVariantGroups(id) {
        return this.http.get<any>(`${environment.coreUrl}Group?parentGroupId=${id}`);
    }

    addInventoryVariantGroups(value) {
        return this.http.post<any>(`${environment.coreUrl}Group`, value);
    }

    loadISettings() {
        return this.http.get<any>(`${environment.inventoryURl}Product/InventorySettings`);
    }

    getAllItemColor(groupId) {
        return this.http.get<any>(`${environment.coreUrl}Type?groupId=${groupId}`);
    }

    saveItemColor(data) {
        return this.http.post<any>(`${environment.coreUrl}Type`, data);
    }

    loadTrackingOptions(): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}TrackingSetting`);
    }

    checkIsDuplicateItem(itemNo, productId) {
        let params = new HttpParams();
        params = params.append('itemNo', itemNo)
        params = params.append('productId', productId)
        return this.http.get<any>(`${environment.inventoryURl}Product/CheckIsDuplicateItemNo`, { params });
    }

    checkIsDuplicateBarcode(barcodeNo, productId) {
        let params = new HttpParams();
        params = params.append('barcode', barcodeNo)
        params = params.append('productId', productId)
        return this.http.get<any>(`${environment.inventoryURl}Product/CheckBarcodeDuplicacy`, { params });
    }

    getAllProductsByPagination(typeId, pageNo, pageSize, filters, isActive, searchValue, searchColumn, sortBy, isAscending) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('IsAscending', isAscending)
        params = params.append('isActive', isActive)
        params = (!sortBy ? params : params.append('SortBy', sortBy))
        params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        params = (!filters ? params : params.append('filter', filters))
        return this.http.get<any>(`${environment.inventoryURl}Product?productTypeId=${typeId}`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));

    }

    getAllProductsBySearch(typeId, pageNo, pageSize, warehouseId, searchValue, productId) {
        let params = new HttpParams();
        params = (!pageNo ? params : params.append('PageNumber', pageNo))
        params = (!pageSize ? params : params.append('PageSize', pageSize))
        params = (!searchValue ? params : params.append('search', searchValue))
        params = (!warehouseId ? params : params.append('warehouseId', warehouseId))
        params = params.append('showKit', false)
        params = params.append('productId', productId)
        return this.http.get<any>(`${environment.inventoryURl}Product/GetProductsBySearch?typeId=${typeId}`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                inventory: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }

    getProductsByIds(ids, warehouseId) {
        let params = new HttpParams();
        params = (!warehouseId ? params : params.append('warehouseId', warehouseId))
        params = (params.append('includeDeleted', false))
        return this.http.get<any>(`${environment.inventoryURl}Product/ProductDetailsById?productsId=${ids}`, { params });
    }


    getAllService() {
        return this.http.get<any>(this.localAppUrl + 'allService')
            .toPromise()
            .then(res => res);
    }
    getAllBundle() {
        return this.http.get<any>(this.localAppUrl + 'allBundle')
            .toPromise()
            .then(res => res);
    }

    getAllItemHistory(itemId, locationId) {
        const locId = (locationId ? locationId : 0);
        return this.http.get<any>(`${environment.inventoryURl}Product/ProductDetailById?productId=${itemId}&warehouseId=${locId}`)
            .toPromise()
            .then(res => res);
    }

    addCase(c) {
        return this.http.post<any>(this.localAppUrl + 'allProducts/', c)
            .toPromise()
            .then(res => res);
    }

    addProduct(c) {
        return this.http.post<any>(`${environment.inventoryURl}Product`, c)
            .toPromise()
            .then(res => res);
    }

    updateProduct(c, deleteAllFlag, refId) {
        let params = new HttpParams();
        params = (!deleteAllFlag ? params : params.append('deleteAllTracking', deleteAllFlag))
        params = (!refId ? params : params.append('referenceId', refId))
        return this.http.put<any>(`${environment.inventoryURl}Product`, c, { params })
            .toPromise()
            .then(res => res);
    }

    uploadImage(imageData) {
        return this.http.post<any>(`${environment.coreUrl}Attachment`, imageData)
            .toPromise()
            .then(res => res);
    }

    getCaseById(caseId) {
        let url = this.localAppUrl + 'allCases/' + caseId;
        return this.http.get<any>(url).toPromise().then(res => res);;
    }

    updateCase(oneCase) {
        return this.http.put(this.localAppUrl + 'allCases/' + oneCase.id, oneCase, { headers: this.headers })
            .toPromise()
            .then(() => oneCase);
    }

    checkISDeleteProduct(id) {
        return this.http.get<any>(`${environment.inventoryURl}Product/CheckModuleProductAssociation?productId=${id}`);
    }

    deleteProduct(id) {
        return this.http.delete<any>(`${environment.inventoryURl}Product/${id}`)
            .toPromise()
            .then(res => res);
    }

    checkClearBitData(email) {
        return this.http.get<any>(environment.clearBitAPIURL + email, {
            headers: new HttpHeaders({
                "Authorization": environment.clearBitAPIKey
            })
        })
            .toPromise()
            .then(res => res)
    }

    getAllStages() {
        return this.http.get<any>(this.localAppUrl + 'CaseStages')
            .toPromise()
            .then(res => res);
    }

    updateCaseStage(caseStage) {
        let url = this.localAppUrl + "CaseStages?id=" + caseStage.id + "&caseStageId=" + caseStage.caseStageId
        return this.http.put<any>(url, {
            headers: this.headers
        })
            .toPromise()
            .then(res => res);
    }

    getAllContactSource(companyID: number) {
        return this.http.get<any>(this.coreUrl + 'Source/' + "?organizationId=" + companyID)
            .toPromise()
            .then(res => res);
    }

    getAllCategory() {
        return this.http.get<any>(this.localAppUrl + 'Category')
            .toPromise()
            .then(res => res);
    }

    getAllSubCategory() {
        return this.http.get<any>(this.localAppUrl + 'SubCategory')
            .toPromise()
            .then(res => res);
    }

    getAllPirority() {
        return this.http.get<any>(this.localAppUrl + 'Priority')
            .toPromise()
            .then(res => res);
    }

    getAllModules() {
        return this.http.get<any>(`${environment.configUrl}LionO360_Object`)
    }

    getProductById(productId, warehouseId) {
        let params = new HttpParams();
        params = (!warehouseId ? params : params.append('warehouseId', warehouseId))
        return this.http.get<any>(`${environment.inventoryURl}Product/${productId}`, { params })
    }

    getAllCustomFields(id) {
        return this.http.get<any>(`${environment.configUrl}Configuration/CustomAttributes?objectId=${id}`)
            .toPromise()
            .then(res => res);
    }

    getAllCustomFieldTypes(id) {
        return this.http.get<any>(`${environment.configUrl}Configuration/FormControls?objectId=${id}`)
            .toPromise()
            .then(res => res);
    }

    //pricebook API
    getAllProductsTiers(productId, warehouseId) {
        return this.http.get<any>(`${environment.inventoryURl}PriceTier/PriceTierByProduct?productId=${productId}&warehouseId=${warehouseId}`);
    }

    getAllTiers() {
        return this.http.get<any>(`${environment.inventoryURl}PriceTier/PriceTierConfiguration`);
    }

    addBulkPriceTier(value) {
        return this.http.post<any>(`${environment.inventoryURl}PriceTier/ProductPriceTier/BulkAddProductPriceTier?isSave=true`, value)
            .toPromise()
            .then(res => res);
    }

    getOrganizationTypes(groupName): Observable<any> {
        return this.http.get<any>(`${environment.appOrgUrl}Type?groupName=${groupName}`);
    }

    getCategoryGroups(groupName): Observable<any> {
        return this.http.get<any>(`${environment.appOrgUrl}Category/GetAllCategoryByGroup?groupName=${groupName}`);
    }
    getProductQtyBucket(productId, warehouseId, type): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Product/QuantityBucketOrder?productId=${productId}&warehouseId=${warehouseId}&type=${type}`);
    }

    getInStockTracking(pageNo, pageSize, productId, warehouseId, searchValue) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('productId', productId)
        params = params.append('warehouseId', warehouseId)
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        return this.http.get<any>(`${environment.inventoryURl}Product/GetInStockSerialList`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                trackingStocks: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }

    getSoldStockTracking(pageNo, pageSize, productId, warehouseId, searchValue) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('productId', productId)
        params = params.append('warehouseId', warehouseId)
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        return this.http.get<any>(`${environment.inventoryURl}Product/GetSoldSerialList`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                trackingStocks: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }

    getSearialTrackingDetails(productId, serialId): Observable<any> {
        return this.http.get<any>(`${environment.inventoryURl}Product/GetSerialDetailView?productId=${productId}&productQtyTrackingId=${serialId}`);
    }

    getTransactionTracking(pageNo, pageSize, productId, txnNo, txnType) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('productId', productId)
        params = params.append('SortBy', 'CreatedDate')
        params = params.append('IsAscending', true)
        params = (!txnNo ? params : params.append('txnNumber', txnNo))
        params = (!txnType ? params : params.append('txnType', txnType))
        return this.http.get<any>(`${environment.inventoryURl}Product/SerialViewByTransaction`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                tracking: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }

    getSerialCount(productId, warehouseId) {
        return this.http.get<any>(`${environment.inventoryURl}Product/ProductTrackingCount?productId=${productId}&warehouseId=${warehouseId}`);
    }

    setRecentlyViewed(productId) {
        return this.http.get<any>(`${environment.inventoryURl}Product/UpdateRecentlyViewedDate?productId=${productId}`);
    }

    loadTrackingData(productId, warehouseId) {
        let params = new HttpParams();
        params = params.append('PageNumber', 0)
        params = params.append('PageSize', 0)
        return this.http.get<any>(`${environment.inventoryURl}Product/SerialPagedList?productId=${productId}&warehouseId=${warehouseId}`, { params });
    }

    getAllBin(productId, wareHouseId, pageNumber, pageSize, searchColumn, searchValue) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNumber)
        params = params.append('PageSize', pageSize)
        params = params.append('productId', productId)
        params = params.append('warehouseId', wareHouseId)
        params = (!searchColumn ? params : params.append('SearchColumns', searchColumn))
        params = (!searchValue ? params : params.append('SearchValue', searchValue))
        return this.http.get<any>(`${environment.inventoryURl}WarehouseBin/ProductBinList`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                bindata: res.body,
                headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }
    getSalesHistory(productId, warehouseId, pageNo, pageSize, searchValue) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('searchValue', searchValue)
        return this.http.get<any>(`${environment.financeURl}FinancialReport/GetProductSalesHistory?productId=${productId}&warehouseId=${warehouseId}`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                data: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }
    getPurchaseHistory(productId, warehouseId, pageNo, pageSize, searchValue) {
        let params = new HttpParams();
        params = params.append('PageNumber', pageNo)
        params = params.append('PageSize', pageSize)
        params = params.append('searchValue', searchValue)
        return this.http.get<any>(`${environment.financeURl}FinancialReport/GetProductPurchaseHistory?productId=${productId}&warehouseId=${warehouseId}`, { observe: 'response', params })
            .toPromise()
            .then(res => ({
                data: res.body,
                headers: JSON.parse(res.headers.get('x-pagination'))
            }));
    }

}
